<template>
  <li
    class="dropdown nav-item"
    :is="tag"
    :class="{ show: isOpen }"
    aria-haspopup="true"
    :aria-expanded="isOpen"
    @click="toggleDropDown"
    v-click-outside="closeDropDown"
    ref="optionsRowItem"
  >
    <span
      class="nav-link"
      :class="{ 'dropdown-toggle': !removeDropdownTottle }"
      data-toggle="dropdown"
    >
      <slot name="title">
        <i :class="icon"></i>
        <span class="no-icon">{{ title }}</span>
        <b class="caret"></b>
      </slot>
    </span>
    <div class="dropdown-menu show" :class="{ alignRight }" v-show="isOpen">
      <slot></slot>
    </div>
  </li>
</template>
<script>
export default {
  name: "base-dropdown",
  props: {
    title: String,
    icon: String,
    alignRight: Boolean,
    removeDropdownTottle: Boolean,
    tag: {
      type: String,
      default: "li",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropDown() {
      console.log("come on")
      const elements = document.querySelectorAll(".dropdown.nav-item.show")
      elements.forEach((el) => {
        el.classList.remove("show")
      })
      this.isOpen = !this.isOpen;
      this.$emit("change", this.isOpen);
    },
    closeDropDown() {
      this.isOpen = false;
      this.$emit("change", this.isOpen);
    },
    onClassChange(classAttrValue) {
      const classList = classAttrValue.split(' ');

      if (!classList.includes('show'))
        this.isOpen = false;
    }
  },
  watch: {
    class(){
      console.log(this);
    }
  },
  mounted(){
    this.observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        const newValue = m.target.getAttribute(m.attributeName);
        this.$nextTick(() => {
          this.onClassChange(newValue, m.oldValue);
        });
      }
    });

    this.observer.observe(this.$refs.optionsRowItem, {
      attributes: true,
      attributeOldValue : true,
      attributeFilter: ['class'],
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
</script>

<style scoped>
.dropdown .nav-link {
  cursor: pointer;
}

.alignRight {
  right: 0;
  left: unset;
}
</style>
